export default __webpack_public_path__ + "static/media/SL 1BR Park Model.62a06769.jpg";